import type PopperJS from '@popperjs/core';
import Tippy from '@tippyjs/react/headless';
import { Stack } from 'braid-design-system';
import React, { type ReactElement } from 'react';

import { TooltipSpanWrapper } from '../../Tooltip/TooltipTriggerWrapper';

import { CertsyTooltipHeading } from './CertsyTooltipHeading';

import * as styles from '../../Tooltip/Tooltip.css';

interface Props {
  title?: string;
  children: ReactElement;
  tooltipContent: ReactElement;
  offset?: number[];
  placement?: PopperJS.Placement;
  fallbackPlacements?: PopperJS.Placement[];
  zIndex?: number;
}

export const CertsyToolTip = ({
  tooltipContent,
  placement = 'bottom',
  offset = [],
  fallbackPlacements = [],
  zIndex = 200,
  children,
  title = 'Verified credentials',
}: Props) => (
  <Tippy
    render={(attrs) => (
      <div className={styles.certsyTooltip} {...attrs}>
        <Stack space="medium">
          <CertsyTooltipHeading title={title} />
          {tooltipContent}
        </Stack>
      </div>
    )}
    interactive={true}
    placement={placement}
    popperOptions={{
      modifiers: [
        {
          name: 'offset',
          options: {
            offset,
          },
        },
        {
          name: 'flip',
          options: {
            fallbackPlacements,
          },
        },
      ],
    }}
    delay={300}
    zIndex={zIndex}
  >
    <TooltipSpanWrapper>{children}</TooltipSpanWrapper>
  </Tippy>
);
